import { ProductStockStatus } from '@pylot-data/enums/ProductStockStatus.d'
import { useTranslation } from 'next-i18next'
import type { BundleItemOption } from '@pylot-data/pylotschema'
import { sortAlphabetically } from '@components/alfakher/pylot-utils'
import { QuantitySelector } from '../QuantitySelector/QuantitySelector'
import { BundleTypeProps } from './type'
import formStyles from '@commonStyles/Forms.module.scss'
import { getDynamicPriceToAdd } from '../Util/Prices'

export const Select = ({
    selectedBundleProducts,
    setSelectedBundleProducts,
    bundleItem,
    setSelectedLabels,
    selectedLabels,
    dynamicPrice,
    currency,
    locale,
    mainFinalPrice,
    useFlavour = false
}: BundleTypeProps) => {
    const { options, uid } = bundleItem
    const active = selectedBundleProducts[uid as string]?.uid ?? ''
    const { t } = useTranslation('common')
    const filteredProduct = bundleItem.options?.filter((val) => {
        if (val?.label) {
            return val
        }
    })
    const sortedValues = filteredProduct?.sort((a, b) =>
        sortAlphabetically(a?.label, b?.label)
    )
    const renderQty = (
        BundleItemOption: [BundleItemOption],
        active: string,
        uid: string
    ) => {
        const selectedOption = BundleItemOption.find((i) => active == i.uid)
        if (selectedOption) {
            if (selectedOption.can_change_quantity) {
                return (
                    <div className={formStyles.root}>
                        <QuantitySelector
                            quantity={
                                selectedBundleProducts[uid].value as number
                            }
                            setQuantity={(qty: number) => {
                                setSelectedBundleProducts(
                                    {
                                        ...selectedBundleProducts,
                                        [uid as string]: {
                                            uid: active,
                                            value: qty
                                        }
                                    },
                                    selectedOption?.product?.media_gallery
                                )
                            }}
                        />
                    </div>
                )
            }
        }
        return null
    }

    return (
        <>
            <div className={formStyles.root}>
                {/* eslint-disable-next-line jsx-a11y/no-onchange */}
                <select
                    className="form-select block appearance-none w-full bg-grey-lighter border-2 border-grey-lighter text-p-1 py-3 px-4 pr-8 rounded focus:shadow-none focus:border-accents-2 max-w-sm"
                    id="grid-state"
                    value={active as string}
                    onChange={(e) => {
                        e.persist()
                        const productUid = e.target.value
                        const selectedOption = options?.find(
                            (i) => productUid == i?.uid
                        )
                        const getFlavour = () => {
                            const flavour = selectedOption?.product
                                ?.flavour_text
                                ? [selectedOption?.product?.flavour_text]
                                : []

                            if (!flavour[0]) {
                                return getLabel()
                            }

                            return flavour
                        }
                        const getLabel = () => {
                            return selectedOption?.label
                                ? [selectedOption?.label]
                                : []
                        }
                        setSelectedBundleProducts(
                            {
                                ...selectedBundleProducts,
                                [uid as string]: {
                                    uid: productUid as string,
                                    value:
                                        selectedBundleProducts[uid as string]
                                            ?.value ||
                                        (selectedOption?.quantity as number)
                                }
                            },
                            selectedOption
                                ? selectedOption?.product?.media_gallery
                                : []
                        )
                        setSelectedLabels({
                            ...selectedLabels,
                            [uid as string]: useFlavour
                                ? getFlavour()
                                : getLabel()
                        })
                    }}
                >
                    <option selected={active === ''} value="">
                        {t('Select an option...')}
                    </option>
                    {sortedValues?.map((v, i: number) => {
                        const getOption = () => {
                            const flavourText = v?.product?.flavour_text

                            if (useFlavour && flavourText) {
                                return flavourText
                            }

                            return v?.label
                        }
                        const values: string = v?.product?.stock_status ?? ''
                        const OutOfstockValue: boolean = ProductStockStatus.OutOfStock.includes(
                            values
                        )
                        if (!OutOfstockValue) {
                            return (
                                <option key={`${v?.uid}-${i}`} value={v?.uid}>
                                    {getOption()}
                                    {getDynamicPriceToAdd(
                                        v as BundleItemOption,
                                        dynamicPrice,
                                        currency,
                                        locale,
                                        mainFinalPrice
                                    )}
                                </option>
                            )
                        }
                    })}
                </select>
            </div>
            {renderQty(
                options as [BundleItemOption],
                active as string,
                uid as string
            )}
        </>
    )
}
